<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tit">
<a id="page03"></a>
<h2 class="titlePageTitle"><span class="bold">T<span class="small">he</span> D<span class="small"><span class="small">IAMOND</span></span> I<span class="small"><span class="small">SLE</span></span></span></h2>
<p class="titlePageSubtitle"><em class="italic">Book Three of The Dreamtime</em></p>
<h2 class="titlePageAuthor"><span class="bold">STAN NICHOLLS</span></h2>
<p class="colophon"><img alt="logo" src="logo.jpg"/></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?0b43d24b